import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";

import { Action } from "types/generated";

import { GET_SPACES_BY_ACTION } from "./gql";

type UseSpacesByActionOptions = {
  actions: Action[];
};

const useSpacesByAction = ({ actions }: UseSpacesByActionOptions) => {
  const { data, loading, error } = useQuery(GET_SPACES_BY_ACTION, {
    variables: {
      input: {
        actions,
      },
    },
  });

  const spaces = useMemo(() => data?.spaces || [], [data?.spaces]);

  return {
    spaces,
    loading,
    error,
  };
};

export default useSpacesByAction;
